// Strip the leading slash so BASE_URL "/" doesn't produce "//media/..." (a protocol-relative URL)
export const toAbsoluteUrl = (pathname: string) =>
  import.meta.env.BASE_URL + pathname.replace(/^\/+/, '')
